// utils/runWithGuards.js

// you already have this:
export function checkActionAllowed({ isShopOpen, userAddress }) {
  if (!isShopOpen) return { allowed: false, reason: "Restauracja jest zamknięta" };
  if (!userAddress) return { allowed: false, reason: "Ustaw adres dostawy" };
  return { allowed: true, reason: "" };
}

/**
 * Simple boolean guard for generic actions (Add to cart, open modal, etc.)
 * Returns true when allowed, false when blocked.
 * Optionally call onBlocked(reason) if provided.
 */
export function canProceed(opts, onBlocked) {
  const { allowed, reason } = checkActionAllowed(opts);
  if (!allowed) {
    onBlocked?.(reason);
    return false;
  }
  return true;
}

/**
 * Checkout-specific guard with cart checks.
 * Returns { allowed, reason } so you can show UI state (disabled, tooltip) AND use canProceedCheckoutBool.
 */
export function checkCheckoutAllowed({ isShopOpen, userAddress, hasItems, minOrderAmount = 0, cartTotal = 0 }) {
  if (!isShopOpen) return { allowed: false, reason: "Restauracja jest zamknięta" };
  if (!userAddress) return { allowed: false, reason: "Ustaw adres dostawy" };
  if (!hasItems) return { allowed: false, reason: "Koszyk jest pusty" };
  if (minOrderAmount && cartTotal < minOrderAmount) {
    return { allowed: false, reason: `Minimalne zamówienie to ${minOrderAmount.toFixed ? minOrderAmount.toFixed(2) : minOrderAmount} zł` };
  }
  return { allowed: true, reason: "" };
}

/** Boolean helper for checkout */
export function canProceedCheckout(opts, onBlocked) {
  const { allowed, reason } = checkCheckoutAllowed(opts);
  if (!allowed) {
    onBlocked?.(reason);
    return false;
  }
  return true;
}
